import { render, staticRenderFns } from "./user_black_list.vue?vue&type=template&id=32325a3a&scoped=true&"
import script from "./user_black_list.vue?vue&type=script&lang=js&"
export * from "./user_black_list.vue?vue&type=script&lang=js&"
import style0 from "./user_black_list.vue?vue&type=style&index=0&id=32325a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32325a3a",
  null
  
)

export default component.exports